import { render, staticRenderFns } from "./MessageNotice.vue?vue&type=template&id=f41e87b2&scoped=true"
import script from "./MessageNotice.vue?vue&type=script&lang=js"
export * from "./MessageNotice.vue?vue&type=script&lang=js"
import style0 from "./MessageNotice.vue?vue&type=style&index=0&id=f41e87b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f41e87b2",
  null
  
)

export default component.exports